


































































import Vue from "vue";
import { mapActions } from "vuex";
import { ItemConditionOptions } from "../../types";
export default Vue.extend({
  data(): { [key: string]: any } {
    return {
      dropdownOptions: ItemConditionOptions
    };
  },
  props: {
    data: {
      type: Object
    }
  },
  inject: ["modalDoneAction"],
  computed: {
    saveDisabled() {
      return this.data.return_condition.name === "" ? true : false;
    }
  },
  methods: {
    onDropdownOptionSelected(selected: { name: string; display_name: string }) {
      this.data.return_condition = selected;
    }
  }
});
